// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import {EnvironmentType} from '@app/shared/enums/environment-type.enum';

export enum GrowlContent {
  Friendly = "friendly",    // display user friendly error msg
  Technical = "technical",  // display technical error msg
  Details = "details",      // display detailed technical error msg
}

export const environment = {
  instance: EnvironmentType.Sandbox,
  clientId: 'atworksys-angular2',
  enable_cors: true,
  restAPIurl: 'https://sandbox.atworksys.com/dataservices',
  restAPIurlForCSR: "https://sandbox-admin.atworksys.com/dataservices",
  checkUrlForCSR: true,
  rootUrl: "https://sandbox.atworksys.com",
  rootUrlForCSR: "https://sandbox-admin.atworksys.com",

  FINANCE_DASHBOARD_APP_ID: "7b195ab3-6f36-4282-9ae2-5f6ab103becd/sheet/2fafb16e-ff7c-4389-9314-de9a06cca94a/state/analysis",
  HCM_DASHBOARD_APP_ID: "c3e3b22c-3ba3-4f93-a20e-f300d235707d/sheet/d3d8dfac-6c62-4639-929e-0b0439ac81ec/state/analysis",
  PROJECT_DASHBOARD_APP_ID: "6f08c775-c3df-4689-ad60-998b23eb8942/sheet/eeed865a-bf6b-40de-9f49-9e7457f8e614/state/analysis",
  PROCUREMENT_DASHBOARD_APP_ID: "0a2a3df6-52cb-4c1b-85fd-b3bf7de8c0e7/sheet/c455a45a-cf55-438e-b2da-f73e5bf1f5b4/state/analysis",
  EXECUTIVE_DASHBOARD_APP_ID: "d050f0ff-5f6e-4f04-a9df-7fba93336989/sheet/0f8caf06-ae0b-4c2d-9b97-7912e51be866/state/analysis",

  growlNormalTimeout: 3500,
  growlNormalLongerTimeout: 20000,
  growlInfoTimeout: 5000,
  growlWarnTimeout: 5000,
  growlErrorTimeout: 20000,
  growlContent: GrowlContent.Details,

  excludedDefaultOrgIdInURL: [
    {orgId: 'localhost'},
    {orgId: 'dev'},
    {orgId: 'qa'},
    {orgId: 'staging'},
    {orgId: 'beta'},
    {orgId: 'sandbox'},
    {orgId: 'onelynk'},
  ],

  //Urls, http interceptor will not add error mesage in case of exception, it is the responsibility of component to provide feedback to user
  excludeErrorMessageByInterceptorUrls: [
    {url: '/trading-partners/ach-detail', method: 'POST'},
    {url: '/trading-partners/ach-detail', method: 'PUT'},
    {url: '/trading-partners/ach-detail', method: 'DELETE'},
    {url: '/org-unit/ach-detail', method: 'POST'},
    {url: '/org-unit/ach-detail', method: 'DELETE'},
    {url: '/org-unit/ach-detail', method: 'PUT'},
    {url: '/verified-customer/balance', method: 'GET'},
  ],

  // immutable url pattern: http int erceptor will not change the request if the requested url contains the following
  immutableUrls: [
    {url: '.json'},
    {url: 'http://'},
    {url: 'https://'},
    {url: 'uib/template'},
    {url: 'errors/messages.html'}
  ],

  // bypass spinner - should have only look up services
  spinnerUrls: [
    { urlRegex: '/connect/*' },
    { urlRegex: '/hr/users/*/photo*' },
    { urlRegex: '/approval/worklist/status-counts*' }
  ],

  keycloakConfig: {
    realm: 'mu',
    authServerUrl: 'https://sandbox.atworksys.com/auth',
    authServerUrlForCsr: 'https://sandbox-admin.atworksys.com/auth',
    sslRequired: 'external',
    clientId: 'atworksys-angular2',
    autoLogin: false,
    userId: null,
    password: null
  },

  roleCanUpdateCalendar: {
    'COMPLIANCE': 'aw-compliance-calendar-admin-role',
    'TIMESHEET': 'aw-finance-calendar-admin-role',
    'ACCOUNTING': 'aw-finance-calendar-admin-role',
    'BILLING': 'aw-finance-calendar-admin-role',
    'HOLIDAY': 'aw-hcm-calendar-admin-role',
    'PAYROLL': 'aw-payroll-calendar-admin-role'
  },

  // keycloak SSO related variables idle timeout should be 30mins, max timeout should be 10hours, access token timeout should be 5mins, warnings should be given in 5mins
  sso: {
    "SsoIdleTimeout": 1800,
    "SsoMaxTimeout": 36000,
    "AccessTokenTimeout": 300,
    "SsoIdleTimeoutWarning": 300,
    "SsoMaxTimeoutWarning": 300
  },
};
